var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.595,
    height: 27,
    viewBox: "0 0 130.595 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167253",
    "data-name": "Group 167253",
    transform: "translate(-209.046 -198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167252",
    "data-name": "Group 167252",
    transform: "translate(281.641 198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83262",
    "data-name": "Path 83262",
    d: "M13.5,0h31a13.5,13.5,0,0,1,0,27h-31a13.5,13.5,0,0,1,0-27Z",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83156",
    "data-name": "Path 83156",
    d: "M-11.869,2.926h3.008v-3.6h2.285c3.066,0,5.527-1.441,5.527-4.219,0-2.487-1.973-4.185-5.234-4.185h-5.586Zm3.008-5.951V-6.7h2.324c1.5,0,2.441.635,2.441,1.818,0,1.063-.879,1.852-2.383,1.852Zm7.5,5.951H1.7L2.955.233H8.736l1.25,2.693H13.13L7.271-9.165H4.5ZM4.029-2.1,5.845-5.992,7.662-2.1Zm12.91,5.025h3.008V-1.859L25.2-9.079H21.782L18.462-4.26,15.2-9.079H11.685l5.254,7.272Z",
    transform: "translate(23.535 16.838)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83261",
    "data-name": "Path 83261",
    d: "M-68.454,0h5.994c2.844,0,4.716-1.152,4.716-3.456A3.092,3.092,0,0,0-60.1-6.588a2.931,2.931,0,0,0,1.656-2.718,2.915,2.915,0,0,0-.864-2.178A4.549,4.549,0,0,0-62.6-12.6h-5.85Zm2.7-7.506V-10.17h2.736c1.17,0,1.818.468,1.818,1.3,0,.972-.774,1.368-2,1.368Zm0,5.076V-5.2h3.2c1.422,0,2.052.522,2.052,1.368,0,.972-.738,1.4-1.962,1.4ZM-55.1,0h2.772V-4.032h2.142L-47.448,0h3.24l-3.078-4.5a3.913,3.913,0,0,0,2.7-3.906,3.984,3.984,0,0,0-1.08-2.916A5.021,5.021,0,0,0-49.338-12.6H-55.1Zm2.772-6.48V-10.1h2.754c1.35,0,2.178.612,2.178,1.8,0,1.1-.774,1.818-2.124,1.818ZM-42.8,0h2.826l1.152-2.826H-33.5L-32.346,0h2.9l-5.4-12.69H-37.4Zm4.968-5.274,1.674-4.086,1.674,4.086ZM-27.144,0h2.736V-8.01l6.1,8.01h2.358V-12.6h-2.736v7.758l-5.9-7.758h-2.556Zm14.58,0H-7.65c3.96,0,6.7-2.754,6.7-6.3,0-3.582-2.736-6.3-6.7-6.3h-4.914Zm2.772-2.5v-7.6H-7.65a3.619,3.619,0,0,1,3.8,3.8,3.6,3.6,0,0,1-3.8,3.8Z",
    transform: "translate(277.5 218.5)",
    fill: "#1c2023"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandPayIcon);
export default __webpack_public_path__ + "static/media/brandPay_icon.63e01df9419352d091b77f6f2711e28b.svg";
export { ForwardRef as ReactComponent };